<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-select :items="sortSelectionOptions" label="Sort By" dense outlined clearable class="my-2" v-model="sortByField" :menu-props="{ offsetY: true }" @change="onSortByChange" />
    </v-col>
    <v-col cols="12" md="12">
      <v-select :items="pointFilterOptions" label="Points" dense outlined clearable class="my-2" v-model="pointFilter" :menu-props="{ offsetY: true }" @change="onPointsFilterChange" />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "CategoryFilters",

    data() {
      return {
        sortSelectionOptions: [
          {
            text: "Latest added",
            value: "created_at",
          },
          {
            text: "Latest updated",
            value: "updated_at",
          },
        ],
        sortByField: "",
        pointFilterOptions: [
          {
            text: "Less than 5000",
            value: { minPoints: 0, maxPoints: 5000 },
          },
          {
            text: "Less than 10000",
            value: { minPoints: 0, maxPoints: 10000 },
          },
          {
            text: "Less than 20000",
            value: { minPoints: 0, maxPoints: 20000 },
          },
          {
            text: "Less than 30000",
            value: { minPoints: 0, maxPoints: 30000 },
          },
          {
            text: "Less than 40000",
            value: { minPoints: 0, maxPoints: 40000 },
          },
          {
            text: "Less than 50000",
            value: { minPoints: 0, maxPoints: 50000 },
          },
        ],
        pointFilter: "",
      };
    },

    methods: {
      onSortByChange() {
        this.$store.commit("setSortByObj", {
          sortByField: this.sortByField,
          sortByOrder: "desc",
        });

        //reset to first page
        this.$store.commit("setCategoryPaginationInfo", {
          pageSize: 9,
          currentPage: 1,
        });

        this.$emit("fetch-products");
      },

      onPointsFilterChange() {
        this.$store.commit("setPointRangeFilter", this.pointFilter);

        //reset to first page
        this.$store.commit("setCategoryPaginationInfo", {
          pageSize: 9,
          currentPage: 1,
        });

        this.$emit("fetch-products");
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Catalog/CategoryFilters.vue